import { RepairFormulaUpdatableInterface } from '../interfaces/repair-formula-updatable.interface';
import { RepairFormulaDto } from './repair-formula.dto';
import { PartialType, PickType } from '@nestjs/swagger';

export class RepairFormulaUpdateDto
  extends PartialType(
    PickType(RepairFormulaDto, [
      'repairId',
      'repairBumperPaymentType',
      'repairResourceType',
      'repairPaymentType',
      'active',
      'repair',
    ]),
  )
  implements RepairFormulaUpdatableInterface {}
